import styled from "styled-components";
import { colors, spacingExtender } from "ui-components";

const RiskSectionInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-bottom: 1px solid ${colors.lightGrey};
`;

const RiskSectionInfoHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: ${colors.whiteGrey};
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
`;

const RiskSectionInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.maroon};
  ${() => spacingExtender({ paddingV: "3", paddingH: "4" })};
`;

export {
  RiskSectionInfoWrapper,
  RiskSectionInfoHeader,
  RiskSectionInfoContent
};



// WEBPACK FOOTER //
// ./src/common/components/RiskSectionInfo/styled.js